import {
  AccountType,
  EditAccountType,
  EditParametersType,
  EditSettingsType,
  AddAccountParametersType,
  AccountActiveType,
} from "@jobintrans/base-ui.types.api"
import { APIService } from "./APIService"

const isActive = (email: string) =>
  APIService.post<null, AccountActiveType>(`/accounts/is-active?email=${email}`)
const add = (body: AddAccountParametersType) =>
  APIService.post<null, AccountType>(`/accounts/:accountId`, body)
const get = () => APIService.get<null, AccountType>(`/accounts/:accountId`)
const update = (data: EditAccountType) =>
  APIService.patch<null, AccountType>(`/accounts/:accountId`, data)
const updateParameters = (data: EditParametersType) =>
  APIService.patch<null, AccountType>(`/accounts/:accountId/parameters`, data)
const updateSettings = (data: EditSettingsType) =>
  APIService.patch<null, AccountType>(`/accounts/:accountId/settings`, data)

export const AccountService = {
  add,
  get,
  update,
  updateParameters,
  updateSettings,
  isActive,
}
